import type { Theme } from '@mui/material';

export const styles = {
  dashboardPage: (theme: Theme) => ({
    '& .PageFrame-children': {
      backgroundColor: theme.colors.neutral[100],
      pl: 3,
    },
  }),

  loadingIndicator: (theme: Theme) => ({
    color: theme.palette.common.white,
    position: 'absolute',
  }),

  buttonHelpModal: {
    float: 'right',
  },
};
